import {useColorThemeType, useFontTheme} from '../../../appStyles/hooks/theme';

import {Box} from '@buncha/components/core/view';
import {CustomText} from '../../core/text';
import React from 'react';
import {TabData} from '../../composites/Tabs/type';
import {styles} from './styles';

export const ItemTabNode: React.FC<{info: TabData<any>; activeKey: string}> =
  React.memo(props => {
    const defaultTheme = useColorThemeType();
    const muliFont = useFontTheme('muli');
    const {info, activeKey} = props;
    return (
      <Box
        style={[
          styles.tabNode,
          // eslint-disable-next-line react-native/no-inline-styles
          {
            borderBottomWidth: activeKey === info.key ? 2 : 1,
            borderBottomColor:
              activeKey === info.key
                ? defaultTheme?.text.blue[300]
                : defaultTheme?.text.gray[100],
          },
        ]}>
        <CustomText
          // eslint-disable-next-line react-native/no-inline-styles
          style={{
            color: defaultTheme?.text.blue[300],
            fontFamily:
              activeKey === info.key
                ? muliFont[700].normal
                : muliFont[400].normal,
          }}>
          {info.data}
        </CustomText>
      </Box>
    );
  });
